var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { msg, localized } from '@lit/localize';
let InputDate = class InputDate extends LitElement {
    constructor() {
        super(...arguments);
        this.placeholder = '';
        this.special = false;
        this.value = '';
        this.size = 'medium';
        this.variant = 'primary';
    }
    handleInput(e) {
        const target = e.target;
        this.value = target.value;
        this.dispatchEvent(new CustomEvent('input-date', {
            detail: this.value,
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        const variantClass = `date-input--${this.variant}`;
        const sizeClass = `date-input--${this.size}`;
        const specialClass = this.special ? 'date-input--special' : '';
        return html `
      <input
        class="date-input ${variantClass} ${sizeClass} ${specialClass}"
        type="date"
        .value=${this.value}
        placeholder=${this.placeholder || msg('Date...', { id: 'form.placeholder.date', desc: 'Date input placeholder' })}
        min=${this.min ?? ''}
        max=${this.max ?? ''}
        @input=${this.handleInput}
      />
    `;
    }
};
InputDate.styles = css `
    .date-input {
      padding: 8px 12px;
      border: 1px solid #ddd;
      border-radius: 8px;
      font-size: 14px;
      width: 100%;
      box-sizing: border-box;
      transition: border 0.3s, box-shadow 0.3s, background-color 0.3s;
    }
    .date-input:focus {
      border-color: #0078d4;
      box-shadow: 0 0 0 3px rgba(0, 120, 212, 0.2);
      outline: none;
    }
    /* Variants */
    .date-input--primary {
      border-color: #0078d4;
    }
    .date-input--secondary {
      border-color: #6c757d;
    }
    .date-input--success {
      border-color: #28a745;
    }
    .date-input--danger {
      border-color: #dc3545;
    }
    .date-input--warning {
      border-color: #ffc107;
    }
    /* Sizes */
    .date-input--small {
      font-size: 12px;
      padding: 6px 10px;
    }
    .date-input--medium {
      font-size: 14px;
      padding: 8px 12px;
    }
    .date-input--large {
      height: 47px;
      font-size: 20px;
      line-height: 1.5;
      padding: 0 14px;
    }
    /* Special styles */
    .date-input--special {
      background-color: rgba(0, 120, 212, 0.1);
    }
    .date-input--special.date-input--primary {
      background-color: rgba(0, 120, 212, 0.1);
    }
    .date-input--special.date-input--secondary {
      background-color: rgba(108, 117, 125, 0.1);
    }
    .date-input--special.date-input--success {
      background-color: rgba(40, 167, 69, 0.1);
    }
    .date-input--special.date-input--danger {
      background-color: rgba(220, 53, 69, 0.1);
    }
    .date-input--special.date-input--warning {
      background-color: rgba(255, 193, 7, 0.1);
    }
  `;
__decorate([
    property({ type: String })
], InputDate.prototype, "placeholder", void 0);
__decorate([
    property({ type: Boolean })
], InputDate.prototype, "special", void 0);
__decorate([
    property({ type: String })
], InputDate.prototype, "value", void 0);
__decorate([
    property({ type: String })
], InputDate.prototype, "size", void 0);
__decorate([
    property({ type: String })
], InputDate.prototype, "variant", void 0);
__decorate([
    property({ type: String })
], InputDate.prototype, "min", void 0);
__decorate([
    property({ type: String })
], InputDate.prototype, "max", void 0);
InputDate = __decorate([
    localized(),
    customElement('input-date')
], InputDate);
export { InputDate };
//# sourceMappingURL=InputDate.js.map